import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      // Custom typography classes that should not conflict with text-color
      "font-style": [
        "text-title",
        "text-headline",
        "text-headline-md",
        "text-headline-xl",
        "text-subline",
        "text-subline-bold",
        "text-subline-sm",
        "text-lead",
        "text-copy",
        "text-copy-bold",
        "text-copy-sm",
        "text-label",
        "text-input",
        "text-button",
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
